import React from "react";
import { NavLink } from "react-router-dom";
import { Headline } from "../headline/Headline";
import External from '../../assets/img/icn-external.svg';

import './Navcard.sass';

interface NavcardProps {
    image: string;
    title: string;
    text: string;
    link: string;
    onClick?: () => void;
    target?: "external" | "";
}

function Navcard(props: NavcardProps) {
    return (
        <NavLink to={props.link} target={props.target} className="navcard" onClick={props.onClick}>
            <img src={props.image} alt={props.title} />
            <span>
                <Headline level="h2">{props.title}</Headline>
                <p>{props.text}</p>
            </span>
            {props.target === "external" ? <img src={External} alt='Icon für externe Links' /> : ""}
        </NavLink>
    );
}

export default Navcard;